<script>
    import { MapStore } from './map-store'
    import {tick, getContext } from 'svelte'

    let showInfoState = getContext('Section.activeNotebookStore') || new MapStore();
    let showInfoStore = showInfoState.store;

    export let uuid;
    export let title = null;
    export let sections = [];
    export let extraClass = undefined;

    export let showHeader = true;

    export let hasInfo = false;

    let topicElement;
    $: showInfo = $showInfoStore.get(uuid) || false;

    async function toggleInfo () {
        let visible;
        showInfoState.tx(theMap => {
            visible = !theMap.get(uuid);
            theMap.set(uuid, visible);
        });

        await tick();

        if (topicElement && visible) {
          const maybeInfo = topicElement.querySelector('[slot=info]');
          if (maybeInfo) maybeInfo.scrollIntoView();
        }
    }
</script>

<style>
    .topic-header {
        background-color: #F1F1F2;
        align-items: center;
        min-height: 150px;
        border-bottom: 1px solid #c7c7c8;
        margin-bottom: 2em;
        border-top: 3px solid #2C9ABB;
        display: flex;
    }

    .topic-header.empty {
        height: 0;
        min-height: 0;
        margin-bottom: 0;
    }

    .topic-title {
        flex: 1;
        padding-left: 3em;
        display: flex;
        align-items: center;
    }

    .topic-title i.icon {
        font-size: 2em;
        margin-left: 0.25em;
    }

    i.icon-info-solid {
        color: #879090;
    }

    /*.topic-margin {
        margin-left: 45px;
        margin-right: 45px;
    }

    @media (max-width: 767px) {
        .topic-margin {
            margin-left: 20px;
            margin-right: 20px;
        }
    }

    @media (max-width: 440px) {
        .topic-margin {
            margin: 0;
        }
    }*/

    .topic-title h3 {
        margin-top: 10px;
        font-weight: 700;
    }

    @media print {
        .topic-header {
            break-after: avoid;
            page-break-after: avoid;
            min-height: 60px;
            vertical-align: middle;
            margin-bottom: 1em;
            page-break-inside: avoid;
            break-inside: avoid-page;
            border-top: 1px solid #c7c7c8;
        }

        .topic-title {
            break-after: avoid;
            page-break-after: avoid;
            page-break-inside: avoid;
            break-inside: avoid-page;
            padding-left: 0;
            display: block;
        }

        h3.d-inline-block {
            display: block;
        }

        .topic-title i {
            display: none;
        }

        [name="header"] {
            break-after: avoid;
            page-break-after: avoid;
        }
    }

    @media print {
        [data-action="showTopicMetadata"] {
            display: none;
        }
    }

    [data-action="showTopicMetadata"] {
        background: transparent;
        border: none;
        padding: 0;
        margin: 0;
    }

    [data-action="showTopicMetadata"] > i:before {
        vertical-align: text-bottom;
    }
</style>

<div bind:this={topicElement} class="topic {extraClass || ''}">
    <slot name="header">
        {#if showHeader && title }
            <div class="topic-header">
                <div class="topic-title">
                    <h3 class="d-inline-block">{title}</h3>
                    <button on:click={toggleInfo} data-action="showTopicMetadata">
                        {#if hasInfo}
                            <i class="icon icon-info-solid"></i>
                        {/if}
                    </button>
                </div>
            </div>
        {:else}
            <div class="topic-header empty"></div>
        {/if}
    </slot>

    {#each sections as section (section.id || section.uuid || section)}
        <slot name="section" {section}></slot>
        <!--<Section {...section} showTitle={section.title != title}></Section>-->
    {/each}

    {#if hasInfo && showInfo}
        <hr class="print-hidden"/>
    {/if}

    <slot name="info" {showInfo}></slot>
</div>

